<style lang="scss">
#mitarbeiter {
  .employees {
    margin-top: 40px;
    .row {
      .employeecontainer {
        border: 1px solid $c-dark-grey;
        text-align: center;
        cursor: pointer;
        transition: 0.2s all;
        padding: 10px 0;

        &:hover {
          border-color: $c-dark-blue;
          color: $c-dark-blue;
        }
      }
    }
  }
}
</style>

<template>
  <div id="mitarbeiter">
    <Headline h1="Mitarbeiter:innen" />
    <div class="container-fluid employees">
      <div class="row align-items-center">
        <div class="offset-9 col-3 p-1 mb-3">
          <LabeledInput label="Suche" v-model="filter" />
        </div>
      </div>
      <div class="row align-items-center">
        <div class="col-3 employee p-1" :key="employee.id" v-for="employee in filteredEmployees" @click="gotoWorker(employee.id)">
          <div class="employeecontainer">
            <div class="name">
              {{ combinedName(employee) }}
            </div>
            <div class="unit">
              {{ unitName(employee.unit_id) }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, ref } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import LabeledInput from '@/components/util/LabeledInput.vue';

type Employee = {
  id: number;
  email: string;
  username: string;
  firstname: string;
  lastname: string;
  unit_id: number;
};

export default defineComponent({
  setup() {
    const store = useStore();
    const router = useRouter();
    const employees = ref<Array<Employee>>([]);
    const units = computed(() => store.getters.getUnits);
    const filter = ref('');
    store.dispatch('fetchWorkers').then((res: Array<Employee>) => {
      employees.value = res;
    });
    store.dispatch('fetchUnits');

    const filteredEmployees = computed(() =>
      employees.value.filter(
        (item: Employee) => filter.value == '' || combinedName(item).toLocaleLowerCase().includes(filter.value.toLocaleLowerCase())
      )
    );

    const combinedName = (employee: Employee) => {
      if (employee.firstname && employee.lastname) {
        return `${employee.firstname} ${employee.lastname}`;
      }
      if (employee.username) return employee.username;
      return 'Kein Name';
    };
    const unitName = computed(() => (id: number) => {
      const unit = units.value.find((unit: any) => unit.id == id);
      return unit ? unit.name : '-';
    });
    const gotoWorker = (id: number) => {
      router.push({ name: 'OverviewPersonal', params: { id } });
    };
    return {
      filteredEmployees,
      combinedName,
      unitName,
      units,
      filter,
      gotoWorker,
    };
  },
  components: { LabeledInput },
});
</script>
